import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouteEditContainer } from './routes/containers/Route/RouteEditContainer';
import { ShowRouteContainer } from './routes/containers/Route/ShowRouteContainer';
import { LoadingProvider } from './routes/components/Loading/Loading';

const container = document.getElementById('routes');
const containerShow = document.getElementById('routes_show');

if (container) {
  createRoot(container).render(
    <LoadingProvider>
      <RouteEditContainer />
    </LoadingProvider>
  );
}

if (containerShow) {
  createRoot(containerShow).render(
    <LoadingProvider>
      <ShowRouteContainer />
    </LoadingProvider>
  );
}

